import {UI} from "../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../stem-core/src/ui/Style";

import {styleRule} from "../../../../stem-core/src/decorators/Style";
import {registerStyle, Theme} from "../../../../stem-core/src/ui/style/Theme";
import {BlinkPayLogo} from "../../../SVGElements";
import {WidgetRoutes} from "../../WidgetRoutes";
import {WALLET_COLLAPSED_WIDTH} from "../../WidgetConstants";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement";
import {Router} from "../../../../stem-core/src/ui/Router";
import {UserPreferencesStore} from "../../../State";
import {RollAnimatedBalance} from "../../../common/RollAnimatedBalance";
import {POPUP_GATE_TRANSITION_TIME} from "../../../../blink-sdk/Constants";


class IndexCollapsedStyle extends StyleSheet {
    transitionDuration = POPUP_GATE_TRANSITION_TIME;

    @styleRule
    indexCollapsed = {
        background: this.themeProps.WALLET_13,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 5,
        opacity: 1,
        transition: `${this.transitionDuration / 2}ms linear`,
        cursor: "pointer",
    };

    @styleRule
    whiteScreen = {
        background: () => this.themeProps.WHITE + " !important",
    };

    @styleRule
    invisible = {
        opacity: "0 !important",
    };

    @styleRule
    unclickable = {
        pointerEvents: "none",
    };

    @styleRule
    balance = {
        fontSize: 18,
        fontWeight: "initial",
        width: "58px !important",
        height: "1em",
        color: Theme.props.WALLET_BALANCE_COLOR,
        transform: "translateY(-3px) !important",
        marginLeft: 10,
    }
}

@registerStyle(IndexCollapsedStyle)
export class IndexCollapsed extends WidgetActiveRouteElement {
    expanded = false;
    static invisibleTimeout;
    static unclickableTimeout;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const {indexCollapsed, unclickable, invisible} = this.styleSheet;
        attr.addClass(indexCollapsed);
        attr.setAttribute("test-id", "widgetIndexCollapsed");
        if (this.expanded) {
            attr.addClass(unclickable);
            attr.addClass(invisible);
        }
    }

    render() {
        const balanceElement = UserPreferencesStore.getPreferences()?.shouldShowBalanceInline() ?
            <RollAnimatedBalance className={this.styleSheet.balance}/> : null;

        return [
            <BlinkPayLogo size={balanceElement ? 24 : 31}/>,
            balanceElement
        ]
    }

    // TODO: Maybe the show and hide should be implemented on a redraw based logic.
    static hide() {
        const {instance} = this;
        if (instance.expanded) {
            return;
        }
        instance.expanded = true;
        const {transitionDuration, invisible, unclickable, whiteScreen} = instance.styleSheet;
        instance.addClass(whiteScreen);
        this.invisibleTimeout = instance.attachTimeout(() => {
            if (instance.expanded) {
                instance.addClass(invisible);
                clearTimeout(this.invisibleTimeout);
            }
        }, transitionDuration / 3.5);
        this.unclickableTimeout = instance.attachTimeout(() => {
            if (instance.expanded) {
                instance.addClass(unclickable);
                clearTimeout(this.invisibleTimeout);
            }
        }, transitionDuration / 2);
    }

    static show() {
        const {instance} = this;
        instance.expanded = false;
        clearTimeout(this.invisibleTimeout);
        clearTimeout(this.unclickableTimeout);
        const {whiteScreen, invisible, unclickable} = instance.styleSheet;
        instance.removeClass(unclickable);
        instance.removeClass(invisible);
        instance.removeClass(whiteScreen);
        instance.dispatchHeightChange();
    }

    computeHeight() {
        return WALLET_COLLAPSED_WIDTH;
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => Router.changeURL(WidgetRoutes.INDEX_EXPANDED));
        this.attachChangeListener(UserPreferencesStore, () => this.redraw());
    }
}
